export const contactAddresses = [
    {
        id: 1,
        office: 'National Headquarters',
        addresses: [
            {
                id: 1,
                text: 'FCT:',
                address: 'Bwari, Abuja P.M.B. 189, Garki, Abuja, Nigeria',
                text3: 'Visit our website:',
                link3: 'http://jamb.gov.org',
                href3: 'http://jamb.gov.org',
                text4: 'Contact:',
                phone: '08123658955',
                text2: 'Email:',
                email: 'support@jamb.gov.ng',
                href: 'mailto:support@jamb.gov.ng'
            },
        ]
    },
    {
        id: 2,
        office: 'Headquarters Annexes',
        addresses: [
            {
                id: 1,
                text: 'Lagos:',
                address: '11 OJORA ROAD, IKOYI, P.M.B. 12748, LAGOS, LAGOS STATE 01-2694751-2',
                text2: 'Email:',
                email: 'lagos@jamb.gov.ng',
                href: 'mailto:lagos@jamb.gov.ng'
            },
            {
                id: 2,
                text: 'FCT:',
                address: 'LIAISON OFFICE FCT 48254-6/264-8 2nd Floor. Annex II, Federal Secretariat Complex Shehu Shagari Way, Abuja.',
                text2: 'Email:',
                email: 'fct@jamb.gov.ng',
                href: 'mailto:fct@jamb.gov.ng'
            },
            {
                id: 3,
                text: 'Kaduna:',
                address: '79, TAFAWA BALEWA WAY, P. M. B. 2200, KADUNA, KADUNA STATE',
                text2: 'Email:',
                email: 'kaduna@jamb.gov.ng',
                href: 'mailto:kaduna@jamb.gov.ng '
            },
        ]
    },
    {
        id: 3,
        office: 'Zonal offices',
        addresses: [
            {
                id: 1,
                text: 'Adamawa:',
                address: 'Former Min. of Education, P. M.8. 2014 Yola',
                text2: 'Email:',
                email: 'adamawa@jamb.gov.ng',
                href: 'mailto:adamawa@jamb.gov.ng'
            },
            {
                id: 2,
                text: 'Bauchi:',
                address: 'Off Ahmadu Bello Way, Opposite State Treasury, P.M.B. 300. Bauchi Bauchi State',
                text2: 'Email:',
                email: 'bauchi@jamb.gov.ng',
                href: 'mailto:bauchi@jamb.gov.ng'
            },
            {
                id: 3,
                text: 'Edo:',
                address: 'Plot 21B,Ikpokpan Road, GRA, P. M. B. 1169, Benin City, Edo State.',
                text2: 'Email:',
                email: 'edo@jamb.gov.ng',
                href: 'mailto:edo@jamb.gov.ng'
            },
            {
                id: 4,
                text: 'Benue:',
                address: '47, Kashim Ibrahim Road, P.M.B. 102299 Makurdi.',
                text2: 'Email:',
                email: 'benue@jamb.gov.ng',
                href: 'mailto:benue@jamb.gov.ng'
            },
            {
                id: 5,
                text: 'Enugu:',
                address: "No. 22, Annang Street, Off Nkpokiti Junction, Ogui New Layout, Former City Girls', Beside Queens School, Enugu, Enugu State.",
                text2: 'Email:',
                email: 'enugu@jamb.gov.ng',
                href: 'mailto:enugu@jamb.gov.ng'
            },
            {
                id: 6,
                text: 'Borno:',
                address: "Opposite Government House Round About Shehu Laminu Way, P. O. Box 1093, Maiduguri, Borno State.",
                text2: 'Email:',
                email: 'borno@jamb.gov.ng',
                href: 'mailto:borno@jamb.gov.ng'
            },
            {
                id: 7,
                text: 'Cross River:',
                address: "100, Marian Road, P. M. B. 1086, Calabar.",
                text2: 'Email:',
                email: 'crossrivers@jamb.gov.ng',
                href: 'mailto:crossrivers@jamb.gov.ng'
            },
            {
                id: 8,
                text: 'Kano:',
                address: "Rumfa College, B. U. K. Road, Kano, Kano State.",
                text2: 'Email:',
                email: 'kano@jamb.gov.ng',
                href: 'mailto:kano@jamb.gov.ng'
            },
            {
                id: 9,
                text: 'Niger:',
                address: "Plot 2, (3 Arms Zone) Along Eastern Bye-pass, Maitumbi Road, P. M. B. 185, Minna. Niger State.",
                text2: 'Email:',
                email: 'niger@jamb.gov.ng',
                href: 'mailto:niger@jamb.gov.ng'
            },
            {
                id: 10,
                text: 'Oyo:',
                address: "Quarters 845, Opposite Ikolaba Grammar School, Agodi G. R. A., Ibadan, P. M. B. 58, Agodi Post Office, Ibadan.",
                text2: 'Email:',
                email: 'oyo@jamb.gov.ng',
                href: 'mailto:oyo@jamb.gov.ng'
            },
            {
                id: 11,
                text: 'Rivers:',
                address: "9, Ozuzu Close 'D* Line, Port Harcourt.",
                text2: 'Email:',
                email: 'rivers@jamb.gov.ng',
                href: 'mailto:rivers@jamb.gov.ng'
            },
            {
                id: 12,
                text: 'Ondo:',
                address: "Quarters 92, Alagbaka Estate Near C.B.N. Office, IBB Avenue Akure.",
                text2: 'Email:',
                email: 'ondo@jamb.gov.ng',
                href: 'mailto:ondo@jamb.gov.ng'
            },
            {
                id: 13,
                text: 'Kwara:',
                address: "JAMB Oyun Bridge, Jebba Road, ilorin, P.M.B. 1371, Ilorin, Kwara State.",
                text2: 'Email:',
                email: 'kwara@jamb.gov.ng',
                href: 'mailto:kwara@jamb.gov.ng'
            },
            {
                id: 14,
                text: 'Imo:',
                address: "Okigwe Road Secretariat Complex,, P. M. B. 1020, Owerri.",
                text2: 'Email:',
                email: 'imo@jamb.gov.ng',
                href: 'mailto:imo@jamb.gov.ng'
            },
            {
                id: 15,
                text: 'Sokoto:',
                address: "3rd Floor, Block 19, Shehu Kangiwa Secretariat, Sokoto.",
                text2: 'Email:',
                email: 'sokoto@jamb.gov.ng ',
                href: 'mailto:sokoto@jamb.gov.ng '
            },
        ]
    },
    {
        id: 4,
        office: 'North East offices',
        addresses: [
            {
                id: 1,
                text: 'Taraba:',
                address: 'Former Accounts Department, Teaching Service Board, Old T/C Road, P. M. B. 1127, Jalingo.',
                text2: 'Email:',
                email: 'taraba@jamb.gov.ng',
                href: 'mailto:taraba@jamb.gov.ng'
            },
            {
                id: 2,
                text: 'Yobe:',
                address: ' Bukar Abba Ibrahim Way, (Formerly Maiduguri Road), P. M. B. 1109, Damaturu.',
                text2: 'Email:',
                email: 'yobe@jamb.gov.ng',
                href: 'mailto:yobe@jamb.gov.ng'
            },
            {
                id: 3,
                text: 'Gombe:',
                address: "Plot No. 2, Doctors' Quarters, C/o General Buhari Housing Estate, G.R.A. New Layout, P. M. B. 133, Gombe.",
                text2: 'Email:',
                email: 'gombe@jamb.gov.ng',
                href: 'mailto:gombe@jamb.gov.ng'
            },
        ]
    },
    {
        id: 5,
        office: 'North West offices',
        addresses: [
            {
                id: 1,
                text: 'Jigawa:',
                address: 'Hussain Adamu Polytechnic, Dutse.',
                text2: 'Email:',
                email: 'jigawa@jamb.gov.ng',
                href: 'mailto:jigawa@jamb.gov.ng'
            },
            {
                id: 2,
                text: 'Katsina:',
                address: 'Funtua Close, Off Bayajidda Road GRA, P. M. B. 2144, Katsina.',
                text2: 'Email:',
                email: 'katsina@jamb.gov.ng',
                href: 'mailto:katsina@jamb.gov.ng'
            },
            {
                id: 3,
                text: 'Zamfara:',
                address: "8, Sokoto Road, Opposite Wambai House, P.M.B. 01120, Gusau.",
                text2: 'Email:',
                email: 'zamfara@jamb.gov.ng',
                href: 'mailto:zamfara@jamb.gov.ng'
            },
            {
                id: 4,
                text: 'Kebbi:',
                address: "1, Justice Usman Mohammed Road, Off Murtala Mohammed Way, Tudun Wada, P. M. B. 1134, Birnin-Kebbi.",
                text2: 'Email:',
                email: 'kebbi@jamb.gov.ng',
                href: 'mailto:kebbi@jamb.gov.ng'
            },
        ]
    },
    {
        id: 6,
        office: 'North central offices',
        addresses: [
            {
                id: 1,
                text: 'Kogi:',
                address: 'Block 574 Salau Atima Housing Estate, Opposite Lokogoma Phase II, P. M. B. 1057, Lokoja.',
                text2: 'Email:',
                email: 'kogi@jamb.gov.ng',
                href: 'mailto:kogi@jamb.gov.ng'
            },
            {
                id: 2,
                text: 'Nasarawa:',
                address: "Former Studio of Nasarawa Broadcasting Service, Near Deputy Governor's Office, Jos Road Secretariat, P.M.B. 107.",
                text2: 'Email:',
                email: 'nasarawa@jamb.gov.ng',
                href: 'mailto:nasarawa@jamb.gov.ng'
            },
            {
                id: 3,
                text: 'Plateau:',
                address: "56, Murtala Muhammed Way P.M.B. 02065 Jos.",
                text2: 'Email:',
                email: 'plateau@jamb.gov.ng',
                href: 'mailto:plateau@jamb.gov.ng'
            },
        ]
    },
    {
        id: 7,
        office: 'South West offices',
        addresses: [
            {
                id: 1,
                text: 'Osun:',
                address: 'Tehnical College Premises, Iwo Raod, P. M. B. 4330, Osogbo.',
                text2: 'Email:',
                email: 'osun@jamb.gov.ng',
                href: 'mailto:osun@jamb.gov.ng'
            },
            {
                id: 2,
                text: 'Ogun:',
                address: "Premises of Ogun State Staff Development Center, Ibrahim Babangida Boulevard, Abeokuta.",
                text2: 'Email:',
                email: 'ogun@jamb.gov.ng',
                href: 'mailto:ogun@jamb.gov.ng'
            },
            {
                id: 3,
                text: 'Ekiti:',
                address: "Beside New CBN, New lyin Road, Ado-Ekiti Ekiti State.",
                text2: 'Email:',
                email: 'ekiti@jamb.gov.ng',
                href: 'mailto:ekiti@jamb.gov.ng'
            },
        ]
    },
    {
        id: 8,
        office: 'South East offices',
        addresses: [
            {
                id: 1,
                text: 'Anambra:',
                address: 'Amawbia By Pass. P.M.B. 6046 Awka.',
                text2: 'Email:',
                email: 'anambra@jamb.gov.ng',
                href: 'mailto:anambra@jamb.gov.ng'
            },
            {
                id: 2,
                text: 'Ebonyi:',
                address: "State Secretariat Complex, Abakaliki.",
                text2: 'Email:',
                email: 'ebonyi@jamb.gov.ng',
                href: 'mailto:ebonyi@jamb.gov.ng'
            },
            {
                id: 3,
                text: 'Abia:',
                address: "Abia State Old Secretariat, 72, School Road (Old Secretariat), Beside Umuahia Township Stadium, Umuahia.",
                text2: 'Email:',
                email: 'abia@jamb.gov.ng',
                href: 'mailto:abia@jamb.gov.ng'
            },
        ]
    },
    {
        id: 9,
        office: 'South South offices',
        addresses: [
            {
                id: 1,
                text: 'Bayelsa:',
                address: '3, Police Headquarters Road, Yenagoa.',
                text2: 'Email:',
                email: 'bayelsa@jamb.gov.ng',
                href: 'mailto:bayelsa@jamb.gov.ng'
            },
            {
                id: 2,
                text: 'Delta:',
                address: "Okpanam Road, By NTA Junction, P. M. B. 95093, Asaba.",
                text2: 'Email:',
                email: 'delta@jamb.gov.ng',
                href: 'mailto:delta@jamb.gov.ng'
            },
            {
                id: 3,
                text: 'Akwa Ibom:',
                address: "Atiku Abubakar Avenue, P. M. B. 1095, Uyo.",
                text2: 'Email:',
                email: 'delta@jamb.gov.ng',
                href: 'mailto:delta@jamb.gov.ng'
            },
        ]
    },
]

